import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NewModalModule } from 'outshared-lib';
import { BicycleCoverageInfoModule } from '../bicycle-coverage-info';
import { CarCoverageInfoModule } from '../car-coverage-info';
import { CaravanCoverageInfoModule } from '../caravan-coverage-info';
import { GeneralCoverageInfoModule } from '../general-coverage-info';
import { MopedCoverageInfoModule } from '../moped-coverage-info';
import { MotorCoverageInfoModule } from '../motor-coverage-info';
import { AdditionalCoverageInfoModalComponent } from './additional-coverage-info-modal.component';

/** @deprecated - this is moved to libs/shared/feature-coverage-modals */
@NgModule({
    imports: [
        CommonModule,
        NewModalModule,

        // modal content
        GeneralCoverageInfoModule,
        BicycleCoverageInfoModule,
        CarCoverageInfoModule,
        CaravanCoverageInfoModule,
        MopedCoverageInfoModule,
        MotorCoverageInfoModule,
    ],
    exports: [AdditionalCoverageInfoModalComponent],
    declarations: [AdditionalCoverageInfoModalComponent],
    providers: [],
})
export class AdditionalCoverageInfoModalModule { }
